import { createAction } from "@reduxjs/toolkit";
import {
    DELETE_PROJECT,
    DeleteProjectAction,
    GET_PROJECTS,
    GET_PROJECT_STATUSES,
    POST_NEW_PROJECT,
    PROJECTS_RECEIVED,
    PROJECT_SELECTED,
    PostNewProjectAction,
    ProjectSelectedAction,
    ProjectsReceivedAction,
    STATUSES_RECEIVED,
    StatusesReceivedAction,
    UPDATE_PROJECT,
    UpdateProjectAction,
    NEW_PROJECT_CREATED,
    ProjectCreatedAction,
    CLEAR_SELECTED_PROJECT
} from "./types";

export const getProjects = createAction(GET_PROJECTS);

export const projectsReceived = createAction<ProjectsReceivedAction["payload"]>(PROJECTS_RECEIVED);

export const projectSelected = createAction<ProjectSelectedAction["payload"]>(PROJECT_SELECTED);

export const postNewProject = createAction<PostNewProjectAction["payload"]>(POST_NEW_PROJECT);

export const updateProject = createAction<UpdateProjectAction["payload"]>(UPDATE_PROJECT);

export const deleteProject = createAction<DeleteProjectAction["payload"]>(DELETE_PROJECT);

export const getProjectStatuses = createAction(GET_PROJECT_STATUSES);

export const statusesReceived = createAction<StatusesReceivedAction["payload"]>(STATUSES_RECEIVED);

export const newProjectCreated = createAction<ProjectCreatedAction["payload"]>(NEW_PROJECT_CREATED);

export const clearSelectedProject = createAction<void>(CLEAR_SELECTED_PROJECT);
